import { SmallGroupActivity } from '../../../types/smallGroup';
import {
  parseEducationAttendees,
} from '../../../types/education';
import ApprovalStampBox from '../ApprovalStampBox';
import SignaturePadField from '../../common/SignaturePadField';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/CleanActivityPanel.css';
import '../../quality/SmallGroupPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: SmallGroupActivity;
}

function SmallGroupRecordPreviewView({ detail }: Props) {
  const attendees = parseEducationAttendees(detail.attendees);

  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>활동 기록서</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            기록번호
            <input readOnly value={detail.recordNo || ''} />
          </label>
          <label>
            소집단 *
            <input readOnly value={detail.groupName || '-'} />
          </label>
          <label>
            활동일
            <input type="date" readOnly value={detail.activityDate || ''} />
          </label>
          <label className="is-span-2">
            활동명 *
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            장소
            <input readOnly value={detail.location || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="quality-form__grid">
          <label className="is-span-2">
            활동내용
            <textarea rows={4} readOnly value={detail.content || ''} />
          </label>
          <label className="is-span-2">
            결과
            <textarea rows={3} readOnly value={detail.resultText || ''} />
          </label>
          <label className="is-span-2">
            다음 계획
            <textarea rows={3} readOnly value={detail.nextPlan || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="ca-section-head">
          <h3>참석자</h3>
        </div>
        <div className="ca-items">
          {attendees.map((row, idx) => (
            <div className="ca-item-card" key={row.id}>
              <div className="ca-item-card__head">
                <strong>참석자 {idx + 1}</strong>
              </div>
              <div className="ca-item-card__grid">
                <label className="is-wide">
                  부서
                  <input readOnly value={row.dept || ''} />
                </label>
                <label className="is-wide">
                  성명
                  <input readOnly value={row.name || ''} />
                </label>
                <div className="is-full">
                  <SignaturePadField value={row.signatureData} disabled />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default SmallGroupRecordPreviewView;
